/**
 * 登録日が「1か月以内」かを判定する。NEW バッジの表示条件に使う。
 *
 * 30日固定ではなくカレンダー上の1か月後を基準にする（月ごとの日数差で見え方が変わらないようにするため）。
 * ちょうど1か月後の瞬間は「1か月以内」に含めない（境界を含めると1か月＋1日ぶん出続けることになるため）。
 *
 * @param createdAt 判定対象の登録日時。未設定・不正な日付は false（バッジを出さない側に倒す）
 * @param now 現在時刻。テストから固定時刻を渡せるようにするための引数で、通常は省略する
 */
export const isWithinOneMonth = (createdAt?: string | Date | null, now: Date = new Date()): boolean => {
  if (!createdAt) return false;
  const created = new Date(createdAt);
  if (Number.isNaN(created.getTime())) return false;

  // カレンダー上でちょうど1か月後（30日固定ではない）。
  // 1/31 のように翌月に同じ日が無い場合、Date の仕様どおり翌々月へ繰り上がる（例: 1/31 → 3/3）
  const oneMonthLater = new Date(created);
  oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);

  return now < oneMonthLater;
};
